module.exports = __webpack_public_path__ + "static/media/r16.0499667d.jpg";